const DIRECTIONS = [
    [0, 1], // horizontal
    [1, 0], // vertical
    [1, 1], // down-right diagonal
    [1, -1], // down-left diagonal
];
function countInDirection(board, player, startCell, direction) {
    let count = 0;
    let cell = applyDirection(startCell, direction);
    while (inBounds(board, cell) && board[cell.row][cell.col] === player) {
        count++;
        cell = applyDirection(cell, direction);
    }
    return count;
}
function applyDirection({ row, col }, [rowDirection, colDirection]) {
    return { row: row + rowDirection, col: col + colDirection };
}
function inBounds(board, { row, col }) {
    return row >= 0 && row < board.length && col >= 0 && col < board.length;
}
export function checkResult({ board, winLength, lastMoveCell, }) {
    const player = board[lastMoveCell.row][lastMoveCell.col];
    if (!player) {
        throw new Error("Invalid checkResult call – board and lastMoveCell don't match");
    }
    for (const direction of DIRECTIONS) {
        const consecutiveCells = 
        // The cells before the cell that's just been played
        countInDirection(board, player, lastMoveCell, [
            -direction[0],
            -direction[1],
        ]) +
            // The cell that's just been played
            1 +
            // The cells after the cell that's just been played
            countInDirection(board, player, lastMoveCell, direction);
        if (consecutiveCells >= winLength) {
            return { status: "win", winner: player };
        }
    }
    const isDraw = board.every((row) => row.every((cell) => cell !== null));
    if (isDraw) {
        return { status: "draw", winner: null };
    }
    return { status: "play", winner: null };
}
